import { AppLanguages, LOCAL_STORAGE_LANGUAGE_KEY } from '@constants';

const getLanguageFromLS = () => {
  return localStorage.getItem(LOCAL_STORAGE_LANGUAGE_KEY) || AppLanguages.Ru;
};

export default getLanguageFromLS;
